import BaseViewModel, { BaseViewModelParams } from './BaseViewModel';
import Guid from 'src/Utils/Guid';

///TODO: Надо бы избавляться от таких моделей, но это повлечет переделку ДФ :(

/** Модель для Uid-поля */
class UuidControlViewModel extends BaseViewModel {
	constructor(params: BaseViewModelParams) {
		super(params);
		// Генерируем Guid
		this.setValue(Guid.createVersion1WithTime());
	}
}

export default UuidControlViewModel;
